import { Subscription as SubscriptionType } from '../../../types/Dashboard.types';

type SubscriptionProps = {
  subscription: SubscriptionType | null;
};

export function Subscription({ subscription }: SubscriptionProps) {
  const rawPlan = subscription?.plan || 'N/A';
  const plan = rawPlan.replace(/_/g, ' ');
  const aiSystemsCreated = subscription?.aiSystemsCreated || 0;
  const aiSystemsAllowed = subscription?.aiSystemsAllowed || 0;
  const usersCreated = subscription?.usersCreated || 0;
  const usersAllowed = subscription?.usersAllowed || 0;

  const aiSystemsPercentage =
    aiSystemsAllowed > 0 ? (aiSystemsCreated / aiSystemsAllowed) * 100 : 0;

  const usersPercentage =
    usersAllowed > 0 ? (usersCreated / usersAllowed) * 100 : 0;

  const planBadgeClasses = subscription
    ? 'bg-purple-100 text-purple-700'
    : 'bg-gray-100 text-gray-800';

  return (
    <div className="bg-white rounded-lg border border-gray-250v2 shadow-sm p-6 flex flex-col gap-2">
      <div className="flex justify-between items-center">
        <h3 className="font-inter font-medium text-xs leading-4 tracking-[0.05em] text-gray-550 text-left uppercase">
          Current plan
        </h3>
        <div className="flex items-center justify-between">
          <span
            className={`px-[10px] py-[2px] rounded-[10px] font-inter font-medium text-xs leading-4 text-center ${planBadgeClasses}`}
          >
            {plan.charAt(0).toUpperCase() + plan.slice(1).toLowerCase()}
          </span>
        </div>
      </div>

      <div className="flex flex-col">
        <div className="grid grid-cols-2 gap-4 pt-2">
          <div className="flex flex-col">
            <p className="font-inter font-normal text-sm leading-5 text-gray-800 text-left">
              My AI Systems
            </p>
            <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden mt-2">
              <div
                className="h-full bg-cyan-200 rounded-full"
                style={{ width: `${aiSystemsPercentage}%` }}
              />
            </div>
            <p className="font-inter font-normal text-[10px] leading-[10px] text-right text-zinc-900">
              {aiSystemsCreated}/{aiSystemsAllowed === Number.MAX_SAFE_INTEGER ? '\u221E' : aiSystemsAllowed}
            </p>
          </div>
          <div className="flex flex-col">
            <p className="font-inter font-normal text-sm leading-5 text-gray-800 text-left">
              My Invited Users
            </p>
            <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden mt-2">
              <div
                className="h-full bg-cyan-200 rounded-full"
                style={{ width: `${usersPercentage}%` }}
              />
            </div>
            <p className="font-inter font-normal text-[10px] leading-[10px] text-right text-zinc-900">
              {usersCreated}/{usersAllowed === Number.MAX_SAFE_INTEGER ? '\u221E' : usersAllowed}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
